import { Menu } from 'antd';
import { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicIcon from '../dynamic-icon';
import useTranslations from '../../hooks/useTranslations';

const { Item, SubMenu } = Menu;

const LIST_MENUS = [
    { path: '/admin/home', key: 'home', title: 'Dashboard', iconName: 'pie' },
    {
        path: '/',
        key: 'transaction',
        title: 'Transaction',
        iconName: 'handshake',
        children: [
            {
                path: '/admin/settlement-process',
                key: 'voucher',
                title: 'Settlement Process',
                iconName: 'handcoin',
            },
            {
                path: '/admin/payout-process',
                key: 'payout',
                title: 'Payout Process',
                iconName: 'coin',
            },
        ],
    },
    {
        path: '/admin/financial-overview',
        key: 'financial',
        title: 'Financial Overview',
        iconName: 'wallet',
    },
    {
        path: '/admin/booking-management',
        key: 'booking',
        title: 'Booking',
        iconName: 'booking',
    },
    {
        path: '/admin/therapist-management',
        key: 'therapist',
        title: 'Therapist',
        iconName: 'therapist',
    },
    {
        path: '/admin/service-management',
        key: 'service',
        title: 'Service',
        iconName: 'service',
    },
    {
        path: '/',
        key: 'system-setting',
        title: 'System Setting',
        iconName: 'setting',
        children: [
            {
                path: '/admin/system-setting.pricing-setting',
                key: 'pricing',
                title: 'Pricing Setting',
                iconName: 'money',
            },
            {
                path: '/admin/system-setting.customer-platform-info',
                key: 'customer-platform-info',
                title: 'Customer Platform Info',
                iconName: 'files',
            },
            {
                path: '/admin/system-setting.platform-regulations',
                key: 'platform-regulations',
                title: 'Platform Regulations',
                iconName: 'files',
            },

            {
                path: '/admin/system-setting.contact-setting',
                key: 'contact',
                title: 'Contact Setting',
                iconName: 'contact',
            },
        ],
    },
];

function Menus() {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * @param {string} path
     * @returns {string}
     */
    const checkIsActive = (path = '') => {
        const [, , pathname] = location.pathname.split('/') || [];

        const currentPath = pathname?.split('.').splice(0, 2).join('.');

        return path?.includes(currentPath) ? 'ant-menu-item-active ant-menu-item-selected' : '';
    };

    const renderMenu = (menus) => {
        return menus.map((menu) => {
            return menu?.children?.length > 0 ? (
                <SubMenu
                    key={menu?.key}
                    title={t(menu?.title?.replaceAll(' ', ''), menu?.title)}
                    className={checkIsActive(menu?.path)}
                    icon={<DynamicIcon iconName={menu?.iconName} />}
                >
                    {renderMenu(menu.children)}
                </SubMenu>
            ) : (
                <Item
                    key={menu.key}
                    className={checkIsActive(menu?.path)}
                    onClick={() => {
                        navigate(menu.path);
                    }}
                    icon={<DynamicIcon iconName={menu?.iconName} />}
                >
                    {t(menu?.title?.replaceAll(' ', ''), menu?.title)}
                </Item>
            );
        });
    };

    return <Menu mode="inline">{renderMenu(LIST_MENUS)}</Menu>;
}

export default memo(Menus);
